import { PlOption } from 'pl-core-services';

export const PL_INTERVAL_OPTIONS: PlOption[] = [
  { value: 'Daily', label: 'Daily' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Semi-annually', label: 'Semi-annually' },
  { value: 'Annually', label: 'Annually' },
  { value: 'Per Semester', label: 'Per Semester' },
  { value: 'Every 2 weeks', label: 'Every 2 weeks' },
  { value: 'Every 3 weeks', label: 'Every 3 weeks' },
  { value: 'Every 4 weeks', label: 'Every 4 weeks' },
  { value: 'Every 5 weeks', label: 'Every 5 weeks' },
  { value: 'Every 6 weeks', label: 'Every 6 weeks' },
  { value: 'Every 7 weeks', label: 'Every 7 weeks' },
  { value: 'Every 8 weeks', label: 'Every 8 weeks' },
  { value: 'Every 9 weeks', label: 'Every 9 weeks' },
  { value: 'Every 10 weeks', label: 'Every 10 weeks' },
  { value: 'Every 11 weeks', label: 'Every 11 weeks' },
];
